import { atom } from "jotai";
import type { HistoryStack } from "./types";

export const MAX_HISTORY = 100;

export const historyStackAtom = atom<HistoryStack>({ undo: [], redo: [] });

export const isApplyingHistoryAtom = atom<boolean>(false);

/**
 * Lets the active node-config form register a "flush pending edits" callback
 * so undo/redo can commit any in-flight keystroke before popping the stack.
 * Singleton — the panel registers in its watch effect, deregisters in cleanup.
 */
export const pendingFormFlushAtom = atom<(() => void) | null>(null);

export const canUndoAtom = atom((get) => get(historyStackAtom).undo.length > 0);
export const canRedoAtom = atom((get) => get(historyStackAtom).redo.length > 0);
